// extracted by mini-css-extract-plugin
module.exports = {"AccountSetup":"AccountSetup_AccountSetup__xxJuK","highlighted":"AccountSetup_highlighted__2jmxp","VerificationBox":"AccountSetup_VerificationBox__2WRcy"};